<form [formGroup]="form" (ngSubmit)="submit()" class="container" *ngIf="!moreInfoSubmitted">

    <span class="bold">Submit More Information</span>
    <div class="bar">
        <div class="login-bar"></div>
    </div>

    <span class="required">Required Field *</span>
    <span class="questions-title">Please answer the following questions:</span>

    <div *ngFor="let q of questions" class="question" [class.error-row]="submitted && form.get(q.key)?.invalid">
        <label>
            {{ q.label }} <span class="asterisk">*</span>
        </label>

        <div class="radio-group">
            <label>
                <input type="radio" [formControlName]="q.key" value="true" />
                Yes
            </label>
            <label>
                <input type="radio" [formControlName]="q.key" value="false" />
                No
            </label>
        </div>
    </div>

    <label class="pad-top">
        What is the reason you want to submit more information about your claim?
        <span class="asterisk">*</span>
    </label>

    <!-- <textarea formControlName="reason" rows="4" maxlength="1000"
        [class.invalid]="submitted && form.get('reason')?.invalid">
    </textarea> -->
    <mat-form-field class="full-width">
        <textarea matInput formControlName="reason" maxlength="1000" rows="3" [class.invalid]="submitted && form.get('reason')?.invalid"></textarea>
        <!-- Character counter (bottom-right) -->
        <mat-hint align="end">
            {{ form.get('reason')?.value?.length || 0 }} / 1000
        </mat-hint>
        <mat-error *ngIf="submitted && form.get('reason')?.invalid">
            Reason is required
        </mat-error>
    </mat-form-field>

    <div class="upload">
        <div class="subsection stand-alone notes">
            <div class="subsection-title" *ngIf="!missingRequiredDocs">What additional documents can you provide?</div>
            <div class="subsection-title" *ngIf="missingRequiredDocs">What additional documents can you provide?
                <span class="error">* Required</span>
            </div>
            <!-- <div class="subsection-text">{{ 'claimsDetail.upload.note1' | translate }}</div>
            <div class="subsection-text">{{ 'claimsDetail.upload.note2' | translate }}</div>
            <div class="subsection-text spaceBottom">{{ 'claimsDetail.upload.note3' | translate }}</div> -->

            <div class="uploaded-documents d-flex justify-content-center align-items-center" (click)="fileInput.click()"
                upscDragNDrop (onFileDropped)="uploadDocument($event, 'Cre-Documents', $event)">
                <input hidden type="file" #fileInput (change)="uploadDocument($event.target.files, 'Cre-Documents', $event)">
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <img class="pb-2" src="../../../../../assets/images/upload-file-icon.png">
                    <div class="attachments-title pb-2">
                        <span class="upload-underline">{{ 'claimsDetail.upload.message1' | translate }}</span> {{
                        'claimsDetail.upload.message2' | translate }}
                    </div>
                    <div class="pb-2">
                        {{ 'claimsDetail.upload.filesAllowed' | translate }}
                    </div>
                </div>
            </div>
            <div class="uploaded-attachments">
                <ul class="your-attachments">
                    <li class="d-inline-flex justify-content-start align-items-center" *ngFor="let file of listOfFiles">
                        <div>{{file.file.name}}</div>
                        <!-- <mat-icon class="delete-icon ml-2" (click)="remove(file)">clear</mat-icon> -->
                         <mat-icon class="delete-icon ml-2" (click)="removeDocument(file, 'Cre-Documents')">clear</mat-icon>
                    </li>
                </ul>
            </div>
        </div>
        <div class="error" *ngFor="let error of errorList">
          The file {{error.filename}} could not be uploaded due to: {{error.error}}.
        </div>
        <div class="error" *ngIf="fileNameError">{{ 'claimsDetail.upload.fileName' | translate }}</div>
        <div class="error" *ngIf="fileTypeError">{{ 'claimsDetail.upload.fileType' | translate }}</div>
        <div class="error" *ngIf="fileTooBig">{{ 'claimsDetail.upload.limit' | translate }}</div>
        <div class="error" *ngIf="systemError">{{ 'common.systemError' | translate }}</div>

    </div>


    <h4>Receiver Details</h4>

    <div formGroupName="receiver" class="grid">

        <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" />
            <mat-error *ngIf="submitted && form.get('receiver.firstName')?.invalid">
                First name is required
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" />
            <mat-error *ngIf="submitted && form.get('receiver.lastName')?.invalid">
                Last name is required
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Email *</mat-label>
            <input matInput formControlName="email" />
            <mat-error *ngIf="submitted && form.get('receiver.email')?.invalid">
                Valid email is required
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Phone#</mat-label>
            <input matInput formControlName="phone" upscPhoneNumber />
            <mat-error *ngIf="submitted && form.get('receiver.phone')?.invalid">
                Phone number is required
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-select required disableRipple formControlName="country" placeholder="Country"
                (selectionChange)="hideState()">
                <mat-option *ngFor="let country of countryList" [value]="country.key">{{country.value}}</mat-option>
            </mat-select>
            <mat-error *ngIf="submitted && form.get('receiver.country')?.invalid">
                Country is required
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Address</mat-label>
            <input matInput formControlName="address" />
            <mat-error *ngIf="submitted && form.get('receiver.address')?.invalid">
                Address is required
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>City</mat-label>
            <input matInput formControlName="city" />
            <mat-error *ngIf="submitted && form.get('receiver.city')?.invalid">
                City is required
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="hidestate">
            <mat-select name="state" formControlName="state" (selectionChange)="recipientAutoCountry()"
                (click)="onClick($event)" placeholder="State">
                <mat-option *ngFor="let state of stateList" [value]="state.id">{{state.state}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Zip Code</mat-label>
            <input matInput formControlName="zip" />
            <mat-error *ngIf="submitted && form.get('receiver.zip')?.invalid">
                Zip code is required
            </mat-error>
        </mat-form-field>

    </div>

    <div class="btnContainer">
        <button type="submit" class="upsc-green-popup-button">Submit Information<mat-icon
                class="icon-key2">keyboard_arrow_right</mat-icon></button>
        <button type="reset" class="upsc-white-button">Cancel<mat-icon
                class="icon-key">keyboard_arrow_right</mat-icon></button>
    </div>
</form>


<div *ngIf="moreInfoSubmitted">
    <upsc-review-submitted-info></upsc-review-submitted-info>
</div>